export enum EventEnum {
    ORDER_RESTAURANT = 'orderRestaurant',
    COMMAND_RESTAURANT = 'commandRestaurant',
    NEW_VERSION = 'newVersion',
    STATUS_CLIENT_PRINTER = 'statusClientPrinter',
}
